import { Box, Container, Grid2, AppBar } from '@mui/material';
import { LinkStyled, TypographyStyledWhite } from './styles';
import React from 'react';
import AbbottLogo from '../../../../assets/icons/abbottLogo.svg';
import IconPhone from '../../../../assets/icons/contactIcon.svg';
import { useNavigate } from 'react-router-dom';
import useMediaQuery from '@mui/material/useMediaQuery';
import Line from '../../../../shared/components/line/index';

export const Header = () => {
  const mobileView = useMediaQuery('(max-width:767px)');
  const navigate = useNavigate();
  return (
    <>
      <AppBar aria-label="navbar" position="static" color="primary">
        <Box
          sx={{ flexGrow: 1, minHeight: '70px' }}
          data-testid="navbar-component"
        >
          <Container
            className="jc-center"
            maxWidth={false}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              margin: '1.25rem 0px',
              paddingInline: '3.125rem !important'
            }}
          >
            <Grid2 container sx={{ alignItems: 'center' }}>
              {!mobileView ? (
                <LinkStyled
                  sx={{ gap: '0px' }}
                  onClick={() => {
                    navigate('/');
                  }}
                >
                  <img src={AbbottLogo} alt="AbbottLogo" />
                  <TypographyStyledWhite
                    color="common.white"
                    style={{ paddingInline: '0.625rem' }}
                  >
                    {'|'}
                  </TypographyStyledWhite>
                  <TypographyStyledWhite
                    color="common.white"
                    style={{ fontWeight: '900', fontSize: '1.375rem' }}
                  >
                    {'NUTRITION'}
                  </TypographyStyledWhite>
                  <TypographyStyledWhite color="common.white">
                    &nbsp;
                  </TypographyStyledWhite>
                  <TypographyStyledWhite
                    color="common.white"
                    style={{ fontWeight: '450', fontSize: '1.375rem' }}
                  >
                    {'APP'}
                  </TypographyStyledWhite>
                </LinkStyled>
              ) : (
                <LinkStyled
                  sx={{ gap: '15px', flexDirection: 'column' }}
                  onClick={() => {
                    navigate('/');
                  }}
                >
                  <img src={AbbottLogo} alt="AbbottLogo" />
                  <Line color="#D9D9D6" width="50%" height="0.0625rem" />
                  <TypographyStyledWhite
                    color="common.white"
                    style={{ fontWeight: '900', fontSize: '1.375rem' }}
                  >
                    NUTRITION
                    <span style={{ fontWeight: '450', fontSize: '1.375rem' }}>
                      {' APP'}
                    </span>
                  </TypographyStyledWhite>
                </LinkStyled>
              )}
            </Grid2>
            <Grid2
              className="d-none"
              container
              textAlign={'left'}
              sx={{ alignItems: 'center', gap: '3.125rem' }}
            >
              <LinkStyled
                onClick={() => {
                  navigate('/contact');
                }}
              >
                <img src={IconPhone} alt="IconPhone" />
                <TypographyStyledWhite
                  color="common.white"
                  variant="body2"
                  style={{ fontSize: '0.875rem', lineHeight: '1.125rem' }}
                >
                  {'CONTACT'}
                </TypographyStyledWhite>
              </LinkStyled>
            </Grid2>
          </Container>
        </Box>
      </AppBar>
    </>
  );
};
